/* @flow */
import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

import JoinInfoPageBirthdate from 'join/components/JoinInfoPageBirthdate';
import SetupAdminRole from './components/SetupAdminRole';
import SetupFullName from './components/SetupFullName';
import SetupGroup from './components/SetupGroup';
import SetupSchool from './components/SetupSchool';
import SetupView from './components/SetupView';
import SetupSmsDevice from './components/SetupSmsDevice';
import SetupSignature from './components/SetupSignature';
import SetupEmail from './components/SetupEmail';
import SetupPIIConsent from './components/SetupPIIConsent';
import SetupPassword from './components/SetupPassword';
import SetupSubscription from './components/SetupSubscription';
import SetupSchoolEmail from './components/SetupSchoolEmail';
import SetupRosterAll from './components/SetupRosterAll';
import SetupRosterConfirm from './components/SetupRosterConfirm';
import SetupRosterChoose from './components/SetupRosterChoose';
import MarketingLayout from 'components/MarketingLayout';
import SetupRole from './components/SetupRole';

import RequireSetup from 'lib/RequireSetup';
import RequireUser from 'lib/RequireUser';

export default (
  <Route>
    <Route component={MarketingLayout}>
      <Route path="/setup(/)" component={SetupView} onEnter={RequireUser}>
        <Route path="/setup/roster/choose" component={SetupRosterChoose} />
        <Route path="/setup/role" component={SetupRole} />
        <Route path="/setup/pii" component={SetupPIIConsent} />
        <Route path="/setup/class" component={SetupGroup} />
        <Route path="/setup/school" component={SetupSchool} />
        <Route path="/setup/signature" component={SetupSignature} onEnter={RequireUser} />
        <Route path="/setup/name" component={SetupFullName} onEnter={RequireUser} />
        <Route path="/setup/device/sms" component={SetupSmsDevice} onEnter={RequireUser} />
        <Route path="/setup/subscriptions" component={SetupSubscription} onEnter={RequireUser} />
        <Route path="/setup/password" component={SetupPassword} onEnter={RequireUser} />
        <Route path="/setup/email" component={SetupEmail} onEnter={RequireUser} />
        <Route path="/setup/admin_role" component={SetupAdminRole} onEnter={RequireUser} />
        <Route path="/setup/roster/all" component={SetupRosterAll} />
        <Route path="/setup/roster/confirm" component={SetupRosterConfirm} />
        <Route path="/setup/school_email" component={SetupSchoolEmail} />
        <Route path="/setup/birthdate" component={JoinInfoPageBirthdate} onEnter={RequireUser} />

        <IndexRoute onEnter={RequireSetup} />
      </Route>
    </Route>
  </Route>
);
